<template>
  <div class="layer" style="background: #fff">
    <div class="blog-view">
      <h1>人工智能评价研究</h1>
      <el-link
       @click="go"
        type="primary"
        style="font-weight: 500;font-size:17px;;margin-top:10px"
      >报告原文</el-link>

      <img src="static/img/home/gz-4.jpg" class="tankImg" />
      <div class="blog-content">
        <p
          class="text"
        >人工智能是一种引发诸多领域，产生颠覆性变革的前沿技术。20世纪50年代“人工智能”被首次提出，距今已有60多年的发展。人工智能以机器学习、深度学习为核心，在视觉、语音、通信等领域快速发展，悄然改变着人们的生活及工作方式。世界上越来越多的国家意识到人工智能技术的重要性与颠覆性，积极地在AI领域深耕布局，培养AI领域人才，抢夺技术先机。当前，中国明确将人工智能作为未来国家重要的发展战略，加强新一代人工智能在医疗、养老、教育等领域的研发应用。2016年起发布《“互联网+”人工智能三年行动实施方案》、《新一代人工智能发展规划》、《促进新一代人工智能产业发展三年行动计划（2018-2020年）》等政策文件。</p>
        <p
          class="text"
        >在此背景下，为了解现今国际上人工智能的发展现状，把握中国在人工智能领域竞争态势，浙江大学信息资源分析与应用研究中心结合中国工程院知识中心“工程科技机构与专家库”项目的数据建设成果，成立专项组开展研究，选取人工智能发展前列的主要国家，在调研国内外人工智能排行的研究与发展现状的基础上，对指标体系和影响力构成进行比较研究，建立指标评价体系，采集调研大量人工智能相关事实型数据，进行建模计算，开展数据挖掘与情报分析，实现量化排名。</p>
        <h3>1 指标体系</h3>
        <p
          class="text"
        >目前各人工智能报告评价体系主要分两类，一类是以完全客观指标进行评价，主要有CS RANKINGS、乌镇智库、领英AI领域人才报告等，其中CS RANKINGS和领英AI领域人才报告客观指标均较单一，乌镇智库包含新增企业数量、融资、专利量等；一类混合采用客观数据指标和主观分析方法，以G20人工智能专题报告为代表。课题组通过对已有人工智能排行榜指标体系进行梳理，调研发现各大排行榜中指标主要包括论文、专利和人员等，但均未将人工智能所属的学科排名和高端人才数量纳入指标，学科排名能够直接反映机构在该学科综合研究实力，高端人才则是领域发展的核心，因此课题组将这两项指标纳入评价体系。,技术路线详见图1，在调研国内外智库排行的研究与发展现状的基础上，对指标体系和影响力构成进行比较研究，构建RIPO指标体系框架，从智库资源（R，Resource indicators）、智库产出（O，Output indicators）、智库知名度（P，Popularity indicators）、智库影响力（I，Impact indicators）四个维度对全球智库进行综合评价，并通过公开途径，获取用于计算榜单排名的大量客观事实数据。同时，根据数据的特点，确定适用的建模方法及权重，继而得到最终的排行榜数据。</p>
        <p class="tz">表1各排行榜主客观指标统计</p>
        <el-table :data="tableData1" border style="width: 100%">
          <el-table-column prop="name" label="排行榜名称" align="center"></el-table-column>
          <el-table-column prop="objective" label="客观指标" align="center"></el-table-column>
          <el-table-column prop="subjective" label="主观指标" align="center"></el-table-column>
          <el-table-column prop="evaluation" label="评价方法" align="center"></el-table-column>
        </el-table>
        <p class="text">课题组经过对上述排行榜指标体系对比分析，并结合指标评价原则，提出了自己的智库评价指标体系（表2），包括6个一级指标，24个二级指标。</p>
        <p class="text">一级指标分为六大模块：论文、专利、学科排名、顶尖专家、资金和产业。</p>
        <p class="tz">表2 人工智能影响力评价指标</p>
        <el-table :data="tableData2" border style="width: 100%" :span-method="arraySpanMethod">
          <el-table-column prop="number" label="序号" align="center"></el-table-column>
          <el-table-column prop="Level1" label="一级指标" align="center"></el-table-column>
          <el-table-column prop="Level2" label="二级指标" align="center"></el-table-column>
        </el-table>
        <h3>2 研究方法和数据</h3>
        <p
          class="text"
        >报告从人工智能科技产出（学术产出和技术专利）、资金投入、产业发展、专家和学科排名六个维度来综合调研中国、美国、英国、加拿大、德国、法国、日本、澳大利亚、以色列、印度、新加坡、韩国十二个国家人工智能发展的状况。文献计量和指标数据建模分析是本报告两个主要研究方法。文献计量的主要对象是人工智能科技产出（学术论文和技术专利）与人才投入、各国资金投入与产业发展状况，及学科排行情况等。指标数据建模分析一般分为原始数据建模前预处理与建模计算2个步骤。</p>
        <p
          class="text"
        >本项目指标数据获取过程中，注重数据的公开、客观、真实、可获得性，通过检索论文数据库、专利数据库、相关排行榜、国家经费网、国际人才专家网等公开途径，获得用于计算榜单排名的大量客观事实数据</p>
        <h3>3 相关成果</h3>
        <p
          class="text"
        >基于数据公开、面向世界、评价透明、计算可重复原则，自2018年起，项目组连续两年发布《人工智能发展水平评价分析报告》。2019年的《报告》相比前一年，评价对象从对美国、中国、德国、英国、日本五国评价扩展到美国、中国、英国、加拿大、德国、法国、澳大利亚、以色列、日本、印度、新加坡、韩国共十二国的人工智能影响力评价。2019年 《报告》显示，我国人工智能发展在资金和专利方面已经超越美国位居世界第一，在产业、学科排名方面仅次于美国位居世界第二，在论文方面排在美国、加拿大、德国、英国之后位居第五，在顶尖专家方面排在美国、加拿大、英国、德国、法国之后位居第六。</p>
        <p class="tz">表3 人工智能影响力排行榜（2018-2019年对比）</p>
        <el-table :data="tableData3" border style="width: 100%">
          <el-table-column prop="country" label="国家" align="center"></el-table-column>
          <el-table-column prop="industry2018" label="产业-2018" align="center"></el-table-column>
          <el-table-column prop="industry2019" label="产业-2019" align="center"></el-table-column>
          <el-table-column prop="money2018" label="资金-2018" align="center"></el-table-column>
          <el-table-column prop="money2019" label="资金-2019" align="center"></el-table-column>
          <el-table-column prop="experts2018" label="顶尖专家-2018" align="center"></el-table-column>
          <el-table-column prop="experts2019" label="顶尖专家-2019" align="center"></el-table-column>
          <el-table-column prop="patent2018" label="专利-2018" align="center"></el-table-column>
          <el-table-column prop="patent2019" label="专利-2019" align="center"></el-table-column>
          <el-table-column prop="discipline2018" label="学科排名-2018" align="center"></el-table-column>
          <el-table-column prop="discipline2019" label="学科排名-2019" align="center"></el-table-column>
          <el-table-column prop="paper2018" label="论文-2018" align="center"></el-table-column>
          <el-table-column prop="paper2019" label="论文-2019" align="center"></el-table-column>
          <el-table-column prop="total2018" label="总得分-2018" align="center"></el-table-column>
          <el-table-column prop="total2019" label="总得分-2019" align="center"></el-table-column>
          <el-table-column prop="rank2018" label="排名-2018" align="center"></el-table-column>
          <el-table-column prop="rank2019" label="排名-2019" align="center"></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "think",
  data() {
    return {
      tableData1: [
        {
          name: "CS RANKINGS",
          objective: "论文",
          subjective: "/",
          evaluation: "客观数量"
        },
        {
          name: "乌镇智库",
          objective: "新增企业数量、融资、专利量",
          subjective: "/",
          evaluation: "客观数量"
        },
        {
          name: "领英全球AI领域人才报告",
          objective: "人才数量",
          subjective: "/",
          evaluation: "客观数量"
        },
        {
          name: "G20人工智能专题报告",
          objective: "论文、专利、经费、机构、人员",
          subjective: "人工智能相关的战略、规划或重大计划、产业布局",
          evaluation: "客观数量+主观分析"
        }
      ],
      tableData2: [
        {
          number: "1",
          Level1: "产业",
          Level2: "CB insights-AI100企业数量"
        },
        {
          number: "2",
          Level1: "",
          Level2: "公司市值或估值"
        },
        {
          number: "3",
          Level1: "资金",
          Level2: "人工智能领域国家经费总数"
        },
        {
          number: "4",
          Level1: "顶尖专家",
          Level2: "TOP1000人工智能专家学者论文总被引"
        },
        {
          number: "5",
          Level1: "",
          Level2: "TOP1000人工智能专家数量"
        },
        {
          number: "6",
          Level1: "",
          Level2: "TOP1000人工智能专家论文人均被引"
        },
        {
          number: "7",
          Level1: "",
          Level2: "图灵奖数量"
        },
        {
          number: "8",
          Level1: "",
          Level2: "ACM Fellow数量"
        },
        {
          number: "9",
          Level1: "",
          Level2: "IEEE FELLOW数量"
        },
        {
          number: "10",
          Level1: "专利",
          Level2: "AI申请量"
        },
        {
          number: "11",
          Level1: "",
          Level2: "AI授权量"
        },
        {
          number: "12",
          Level1: "",
          Level2: "全行业授权量"
        },
        {
          number: "13",
          Level1: "",
          Level2: "AI授权专利/全行业授权专利"
        },
        {
          number: "14",
          Level1: "学科排名",
          Level2: "TOP10数量"
        },
        {
          number: "15",
          Level1: "",
          Level2: "TOP50数量"
        },
        {
          number: "16",
          Level1: "",
          Level2: "TOP100数量"
        },
        {
          number: "17",
          Level1: "",
          Level2: "总量"
        },
        {
          number: "18",
          Level1: "论文",
          Level2: "总量-WoS"
        },
        {
          number: "19",
          Level1: "",
          Level2: "总被引-WoS"
        },
        {
          number: "20",
          Level1: "",
          Level2: "篇均被引-WoS"
        },
        {
          number: "21",
          Level1: "",
          Level2: "总量-会议论文"
        },
        {
          number: "22",
          Level1: "",
          Level2: "总被引-会议论文"
        },
        {
          number: "23",
          Level1: "",
          Level2: "篇均被引-会议论文"
        },
        {
          number: "24",
          Level1: "",
          Level2: "TOP刊发文数量"
        }
      ],
      tableData3: [
        {
          country: "美国",
          industry2018: "21.84",
          industry2019: "23.20",
          money2018: "13.01",
          money2019: "12.86",
          experts2018: "11.76",
          experts2019: "13.92",
          patent2018: "8.27",
          patent2019: "8.57",
          discipline2018: "11.69",
          discipline2019: "13.92",
          paper2018: "16.92",
          paper2019: "18.56",
          total2018: "83.49",
          total2019: "91.03",
          rank2018: "1",
          rank2019: "1"
        },
        {
          country: "中国",
          industry2018: "21.25",
          industry2019: "21.43",
          money2018: "11.28",
          money2019: "13.92",
          experts2018: "6.20",
          experts2019: "8.57",
          patent2018: "7.84",
          patent2019: "9.28",
          discipline2018: "8.39",
          discipline2019: "12.86",
          paper2018: "15.76",
          paper2019: "12.84",
          total2018: "70.71",
          total2019: "78.89",
          rank2018: "2",
          rank2019: "2"
        },
        {
          country: "英国",
          industry2018: "19.19",
          industry2019: "19.63",
          money2018: "12.53",
          money2019: "10.71",
          experts2018: "6.93",
          experts2019: "11.78",
          patent2018: "6.40",
          patent2019: "3.57",
          discipline2018: "7.56",
          discipline2019: "11.78",
          paper2018: "15.03",
          paper2019: "11.42",
          total2018: "67.64",
          total2019: "68.88",
          rank2018: "3",
          rank2019: "3"
        },
        {
          country: "加拿大",
          industry2018: "/",
          industry2019: "16.05",
          money2018: "/",
          money2019: "1.07",
          experts2018: "/",
          experts2019: "12.86",
          patent2018: "/",
          patent2019: "4.28",
          discipline2018: "/",
          discipline2019: "10.71",
          paper2018: "/",
          paper2019: "15.70",
          total2018: "/",
          total2019: "60.66",
          rank2018: "/",
          rank2019: "4"
        },
        {
          country: "德国",
          industry2018: "8.71",
          industry2019: "12.50",
          money2018: "12.77",
          money2019: "8.57",
          experts2018: "5.47",
          experts2019: "10.71",
          patent2018: "6.96",
          patent2019: "6.42",
          discipline2018: "4.64",
          discipline2019: "6.62",
          paper2018: "14.50",
          paper2019: "14.28",
          total2018: "53.0",
          total2019: "58.90",
          rank2018: "5",
          rank2019: "5"
        },
        {
          country: "法国",
          industry2018: "/",
          industry2019: "1.78",
          money2018: "/",
          money2019: "5.36",
          experts2018: "/",
          experts2019: "9.63",
          patent2018: "/",
          patent2019: "5.71",
          discipline2018: "/",
          discipline2019: "7.50",
          paper2018: "/",
          paper2019: "17.14",
          total2018: "/",
          total2019: "47.11",
          rank2018: "/",
          rank2019: "6"
        },
        {
          country: "日本",
          industry2018: "18.84",
          industry2019: "14.28",
          money2018: "11.26",
          money2019: "8.57",
          experts2018: "4.30",
          experts2019: "3.21",
          patent2018: "8.68",
          patent2019: "7.14",
          discipline2018: "2.48",
          discipline2019: "4.28",
          paper2018: "13.04",
          paper2019: "8.56",
          total2018: "58.61",
          total2019: "46.03",
          rank2018: "4",
          rank2019: "7"
        },
        {
          country: "以色列",
          industry2018: "/",
          industry2019: "17.85",
          money2018: "/",
          money2019: "11.78",
          experts2018: "/",
          experts2019: "6.42",
          patent2018: "/",
          patent2019: "1.42",
          discipline2018: "/",
          discipline2019: "2.13",
          paper2018: "/",
          paper2019: "4.28",
          total2018: "/",
          total2019: "43.88",
          rank2018: "/",
          rank2019: "8"
        },
        {
          country: "澳大利亚",
          industry2018: "/",
          industry2019: "1.78",
          money2018: "/",
          money2019: "6.42",
          experts2018: "/",
          experts2019: "7.50",
          patent2018: "/",
          patent2019: "5.00",
          discipline2018: "/",
          discipline2019: "9.63",
          paper2018: "/",
          paper2019: "10.00",
          total2018: "/",
          total2019: "40.33",
          rank2018: "/",
          rank2019: "9"
        },
        {
          country: "印度",
          industry2018: "/",
          industry2019: "10.70",
          money2018: "/",
          money2019: "7.50",
          experts2018: "/",
          experts2019: "4.28",
          patent2018: "/",
          patent2019: "2.14",
          discipline2018: "/",
          discipline2019: "3.21",
          paper2018: "/",
          paper2019: "2.84",
          total2018: "/",
          total2019: "30.67",
          rank2018: "/",
          rank2019: "10"
        },
        {
          country: "新加坡",
          industry2018: "/",
          industry2019: "1.78",
          money2018: "/",
          money2019: "2.13",
          experts2018: "/",
          experts2019: "5.36",
          patent2018: "/",
          patent2019: "2.85",
          discipline2018: "/",
          discipline2019: "8.57",
          paper2018: "/",
          paper2019: "7.14",
          total2018: "/",
          total2019: "27.82",
          rank2018: "/",
          rank2019: "11"
        },
        {
          country: "韩国",
          industry2018: "/",
          industry2019: "1.78",
          money2018: "/",
          money2019: "2.13",
          experts2018: "/",
          experts2019: "2.13",
          patent2018: "/",
          patent2019: "7.85",
          discipline2018: "/",
          discipline2019: "5.36",
          paper2018: "/",
          paper2019: "5.70",
          total2018: "/",
          total2019: "24.94",
          rank2018: "/",
          rank2019: "12"
        }
      ]
    };
  },
  methods: {
    go() {
      window.open(
        "https://ciraa.zju.edu.cn/report/report20200323.pdf",
        "_blank"
      );
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        if (rowIndex === 0) {
          return {
            rowspan: 2,
            colspan: 1
          };
        } else if (rowIndex === 2) {
          return {
            rowspan: 1,
            colspan: 1
          };
        } else if (rowIndex === 3) {
          return {
            rowspan: 6,
            colspan: 1
          };
        } else if (rowIndex === 9) {
          return {
            rowspan: 4,
            colspan: 1
          };
        } else if (rowIndex === 13) {
          return {
            rowspan: 4,
            colspan: 1
          };
        } else if (rowIndex === 17) {
          return {
            rowspan: 7,
            colspan: 1
          };
        } else {
          return {
            owspan: 0,
            colspan: 0
          };
        }
      }

      // if (rowIndex % 2 === 0) {
      //   if (columnIndex === 0) {
      //     return [1, 2]
      //   } else if (columnIndex === 1) {
      //     return [0, 0]
      //   }
      // }
    }
  }
};
</script>

<style lang="scss">
.blog-view {
  margin-top: 5vh;
  width: 50vw;
  .tankImg {
    width: 50vw;
    margin: 20px 0;
  }
  .blog-content {
    font-size: 16px;
    line-height: 28px;
    color: #222;
    word-wrap: break-word;
    p {
      margin-top: 16px;
      margin-bottom: 16px;
    }
    h3 {
      font-weight: 600;
    }
    .tz {
      font-weight: 600;
      text-align: center;
    }
    .text {
      text-indent: 2em;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/blog/Ai.vue